const apiUrl = "https://api.recommender.ipvm.com"
// const apiUrl = "http://localhost:81"

module.exports = { apiUrl }